export default ({ mod = 'default', icon, className, alarmType, ...rest }) => {
  // Check if this is a SOS alarm type
  const isSos = alarmType && alarmType.$isSos;
  
  return (
    <i
      className={`alarmIcon alarmIcon--${mod} evi evi--a-${icon || 'standard'} ${isSos ? 'evi--a-sos' : ''} ${className}`}
      {...rest}
    />
  );
};
